import { Images } from "lucide-react";
import { cn } from "@/lib/utils";

interface PhotoCountBadgeProps {
  /** Photos in the set the thumbnail stands for. Below 2, nothing renders. */
  count: number;
  className?: string;
}

/**
 * The stacked-photos count in a thumbnail's top-left corner, for a thumbnail
 * that stands for a set: a multi-photo record on the Photos tab, or an issue's
 * Before and Latest update tiles. The number is the set's total, never "+N",
 * so it means the same on every screen. Place it inside a `relative` box.
 * See [[photo-count-badge.spec]].
 */
export function PhotoCountBadge({ count, className }: PhotoCountBadgeProps) {
  if (count < 2) return null;
  return (
    <div
      className={cn(
        "pointer-events-none absolute left-1 top-1 z-10",
        className,
      )}
      data-testid="photo-count-badge"
    >
      <span className="inline-flex items-center gap-1 rounded-full bg-black/60 px-1.5 py-0.5 text-[10px] font-medium text-white">
        <Images className="h-2.5 w-2.5" />
        {count}
      </span>
    </div>
  );
}
